var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgenteClinkDirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_12832",
    "data-name": "Raggruppa 12832",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.94,
    height: 70.45,
    viewBox: "0 0 70.94 70.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_5",
    "data-name": "Rettangolo 5",
    width: 70.94,
    height: 70.45,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M60.368,78.108a.708.708,0,0,0,.142-.079L65.358,74.1H54.737l4.848,3.934a.708.708,0,0,0,.142.079l-4.05,11.2a.518.518,0,0,0,.066.478L59.627,95.2a.518.518,0,0,0,.842,0l3.884-5.415a.518.518,0,0,0,.066-.478Z",
    transform: "translate(-26.391 -35.724)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M86.569,20.148a11.516,11.516,0,1,1-6.35,19.177",
    transform: "translate(-38.677 -9.624)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M31.2,39.325a11.509,11.509,0,1,1-6.35-19.177",
    transform: "translate(-5.429 -9.624)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1",
    "data-name": "Ellisse 1",
    cx: 15.416,
    cy: 15.416,
    r: 15.416,
    transform: "translate(18.241 1.036)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M22.824,88.63V83.463A11.157,11.157,0,0,1,33.981,72.306h21.36A11.157,11.157,0,0,1,66.5,83.463V88.63",
    transform: "translate(-11.004 -34.861)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M12.733,88.395V83.463A11.157,11.157,0,0,1,23.89,72.306H10.333A8.333,8.333,0,0,0,2,80.639v9.666",
    transform: "translate(-0.964 -34.861)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M12.733,88.395V83.463A11.157,11.157,0,0,1,23.89,72.306H10.333A8.333,8.333,0,0,0,2,80.639v9.666",
    transform: "translate(-0.964 -34.861)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M107.556,90.306V80.64a8.333,8.333,0,0,0-8.333-8.333H85.615A11.157,11.157,0,0,1,96.772,83.464v4.922",
    transform: "translate(-41.278 -34.862)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M107.556,90.306V80.64a8.333,8.333,0,0,0-8.333-8.333H85.615A11.157,11.157,0,0,1,96.772,83.464v4.922",
    transform: "translate(-41.278 -34.862)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2",
    "data-name": "Rettangolo 2",
    width: 18.153,
    height: 26.492,
    transform: "translate(40.978 65.326) rotate(-80.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_1",
    "data-name": "Linea 1",
    x1: 3.332,
    y1: 0.534,
    transform: "translate(54.052 56.673)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_3",
    "data-name": "Rettangolo 3",
    width: 6.051,
    height: 26.532,
    transform: "translate(42.855 53.369) rotate(-80.886)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1202",
    "data-name": "Tracciato 1202",
    d: "M1.417,0H16.736a1.417,1.417,0,0,1,1.417,1.417v23.7a1.417,1.417,0,0,1-1.417,1.417H1.417A1.417,1.417,0,0,1,0,25.115V1.417A1.417,1.417,0,0,1,1.417,0Z",
    transform: "translate(40.938 65.319) rotate(-80.886)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M110.122,93.094l-6.481-1.039.335-2.089a.733.733,0,0,1,.84-.608l5.032.807a.734.734,0,0,1,.608.841Z",
    transform: "translate(-49.969 -43.078)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenteClinkDirect);
export default __webpack_public_path__ + "static/media/agente-clink-direct.bec928e5d5308a88d0f05a6be06224a8.svg";
export { ForwardRef as ReactComponent };